<template>
	<div class="mh-middle">
		<div class="mh-middle-inner">
			<ContentTitle title="Invoices" />

			<div class="mh-time-top">
				<b-row no-gutters>
					<b-col align-self="center" lg="3" md="12">
						<h2>Invoice List</h2>
					</b-col>
					<b-col align-self="center" lg="9" md="12">
						<div class="mh-time-search">
							<div class="mh-time-search-inner">
								<i class="mh-icon-search"></i>
								<input type="text" placeholder="Search Here..." v-model="search">
							</div>
							<div class="mh-time-status">
								<b-select class="btn-select" v-model="status" :options="invoiceStatuses" text-field="name" value-field="value" />
							</div>
						</div>
					</b-col>
				</b-row>
			</div>

			<div class="mh-middle-container">
				<div class="mh-time-entries-top mh-time-off">
					<b-row class="m-0">
						<b-col cols="12" class="p-0">
							<div class="table-reponsive mh-entries-list">
								<div class="dataTables_wrapper no-footer">
									<data-table v-bind="bindings"
												:showPerPage="false"
												:showEntriesInfo="false"
												:showSearchFilter="false"
												:showPagination="true"
												:showDownloadButton="false"
												sortingMode="single"
												tableClass="table table-curved dataTable"
												ref="dataTable" />
								</div>
							</div>
						</b-col>

						<b-col v-if="isViewingInvoiceDetails" cols="5">
							<b-card no-body class="invoice-details floating mh-card card-outline">
								<b-card-header class="mh-bg-primary d-flex align-items-center">
									<h3 class="card-title">Invoice Details</h3>
									<div class="col-auto ml-auto p-0">
										<button type="button" class="btn btn-link mh-btn-icon" @click="hideInvoiceDetails"><i class="mh-icon-close"></i></button>
									</div>
								</b-card-header>
								<b-card-body class="mh-off-middle">
									<b-row>
										<b-col cols="12">
											<div class="mh-edit-item">
												<span class="supplier">
													<icon name="regular/building" scale="1.5"></icon>
													{{selectedRecord.supplier}}
												</span>
											</div>
										</b-col>
										<b-col cols="6">
											<div class="mh-edit-item">
												<span>
													<i class="mh-icon-calendar"></i>
													{{selectedRecord.date}}
												</span>
											</div>
										</b-col>
										<b-col cols="6">
											<div class="mh-edit-item">
												<span>
													<icon name="hashtag" scale="1.5"></icon>
													{{selectedRecord.invoicenumber}}
												</span>
											</div>
										</b-col>
										<b-col v-if="selectedRecord.description != ''" cols="12">
											<div class="mh-edit-description">
												<div classs="mh-edit-description-p">{{selectedRecord.comments}}</div>
											</div>
										</b-col>
										<b-col v-if="invoice != null && invoice.invoicelines.length > 0" cols="12">
											<b-row class="line-item-heading mb-2">
												<b-col cols="7">Item</b-col>
												<b-col cols="2" class="text-right">Qty</b-col>
												<b-col cols="3" class="text-right">Total</b-col>
											</b-row>
											<b-row v-for="(invoiceline, index) in invoice.invoicelines" :key="index" class="line-item mb-2">
												<b-col cols="7" v-html="invoiceline.name"></b-col>
												<b-col cols="2" class="text-right">
													{{invoiceline.qty}}
												</b-col>
												<b-col cols="3" class="text-right">
													{{invoiceline.linetotal | currency}}
												</b-col>
											</b-row>
											<b-row class="totals mt-2">
												<b-col cols="9" class="text-right">
													<b>Total:</b>
												</b-col>
												<b-col cols="3" class="text-right">
													{{invoice.totalamount | currency}}
												</b-col>
											</b-row>
										</b-col>
										<b-col v-if="invoice != null && invoice.docs.filter(x => x.Client == 'True').length > 0" cols="12">
											<b-row>
												<b-col cols="12">
													<b>Documents</b>
												</b-col>
											</b-row>
											<b-row v-for="(doc, index) in invoice.docs.filter(x => x.Client == 'True')"
												   :key="index"
												   @click="openViewingDocument(doc)"
												   class="document">
												<b-col cols="12">
													<div class="mh-edit-item">
														<span>
															<icon name="regular/file-alt" scale="1.5"></icon>
															{{getFileName(doc.Key)}}
														</span>
													</div>
												</b-col>
											</b-row>
										</b-col>
									</b-row>
								</b-card-body>
							</b-card>
						</b-col>

						<b-col v-if="isViewingSetInvoiceStatusForm" cols="5">
							<b-card no-body class="invoice-details floating mh-card card-outline">
								<b-card-header class="mh-bg-primary d-flex align-items-center">
									<h3 class="card-title">{{approving ? "Approve" : "Reject"}} Invoice</h3>
									<div class="col-auto ml-auto p-0">
										<button type="button" class="btn btn-link mh-btn-icon" @click="hideSetInvoiceStatusForm"><i class="mh-icon-close"></i></button>
									</div>
								</b-card-header>
								<b-card-body class="mh-off-middle">
									<SetInvoiceStatusForm :data="selectedRecord"
														  :approving="approving"
														  :rejecting="rejecting"
														  @close-form="hideSetInvoiceStatusForm"
														  @save-form="saveSetInvoiceStatusForm" />

								</b-card-body>
							</b-card>
						</b-col>
					</b-row>
				</div>
			</div>

			<DocumentViewer :visible="isViewingDocument" :title="title" :filePath="filePath" @hide="closeViewingDocument" />
		</div>
	</div>
</template>

<script>
	import ContentTitle from "./partials/ContentTitle"
	import SortingIcon from "./partials/SortingIcon"
	import TableRowActions from "./partials/TableRowActions"
	import DocumentViewer from "./partials/DocumentViewer"
	import SetInvoiceStatusForm from "./partials/SetInvoiceStatusForm"
	import { bus } from "./../main"
	import moment from "moment"

	export default {
		name: 'InvoicesClientContent',
		components: {
			ContentTitle,
			SortingIcon,
			TableRowActions,
			DocumentViewer,
			SetInvoiceStatusForm
		},
		data: function () {
			return {
				search: "",
				status: 0,
				viewingInvoiceDetails: false,
				selectedRecord: null,
				invoice: null,
				viewDocument: false,
				title: null,
				filePath: null,
				approving: false,
				rejecting: false
			}
		},
		mounted: function () {
			bus.$off('viewDetailsTableRowAction')
			bus.$on('viewDetailsTableRowAction', obj => { this.viewInvoiceDetails(obj) })
			bus.$off('approveInvoiceTableRowAction')
			bus.$on('approveInvoiceTableRowAction', obj => { this.showApproveInvoiceForm(obj) })
			bus.$off('rejectInvoiceTableRowAction')
			bus.$on('rejectInvoiceTableRowAction', obj => { this.showRejectInvoiceForm(obj) })
		},
		watch: {
			invoiceStatuses: {
				immediate: true,
				handler(newValue, oldValue) {
					if (newValue.length > 0) {
						this.$store.dispatch("Invoices/getInvoices", 0)
					}
				}
			},
			search: {
				immediate: true,
				handler(newValue, oldValue) {
					if (this.$refs.dataTable != null) {
						this.$refs.dataTable.search = newValue
						this.$refs.dataTable.setSearch()
					}
				}
			}
		},
		computed: {
			invoices: function () {
				return this.$store.state.Invoices.invoices
					.slice()
					.map(invoice => {
						invoice.sortorder = invoice.status == 3 ? 0 : 1

						return invoice
					})
					.sort(this.$store.getters["Helper/compareValues"]("sortorder", "asc"))
			},
			invoiceStatuses: function () {
				var statuses = this.$store.state.Invoices.invoiceStatuses.slice().filter(x => parseInt(x.value) > 2)

				if (statuses.length > 0)
					statuses.unshift({ name: "", value: "" })

				return statuses
			},
			records: function () {
				var icons = [
					{
						class: "mh-icon-eye",
						title: "View",
						emit: "viewDetailsTableRowAction"
					},
					{
						class: "check",
						title: "Approve",
						emit: "approveInvoiceTableRowAction",
						show: "canApprove"
					},
					{
						class: "times",
						title: "Reject",
						emit: "rejectInvoiceTableRowAction",
						show: "canReject"
					}
				]

				return this.invoices
					.map(x => {
						return {
							id: x.id,
							invoicenumber: x.invoicenumber,
							status: x.status,
							statusname: x.statusname,
							comments: x.comments,
							date: moment(x.date, "DD/MM/YYYY HH:mm:ss A").format("D MMM YYYY"),
							totalamount: `$${parseFloat(x.totalamount).toFixed(2)}`,
							supplier: x.supplier,
							icons: icons,
							canApprove: x.status == "3",
							canReject: x.status == "3"
						}
					})
					.filter(x => {
						return (this.status == 0 || this.status == x.status)
							&& ((x.invoicenumber + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
								|| (x.statusname + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
								|| (x.date + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
								|| (x.totalamount + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
								|| (x.supplier + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1)
					})
			},
			columns: function () {
				var columns = [
					{ key: "date", title: "Date", searchable: true, sortable: true },
					{ key: "invoicenumber", title: "Invoice Number", searchable: true, sortable: true },
					{ key: "statusname", title: "Status", searchable: true, sortable: true },
					{ key: "totalamount", title: "Total Amount", searchable: true, sortable: true },
					{ key: "supplier", title: "Supplier", searchable: true, sortable: true },
					{ key: "", title: "", component: TableRowActions }
				]

				return columns
			},
			bindings: function () {
				return {
					SortingIconComponent: SortingIcon,
					columns: this.columns,
					data: this.records
				}
			},
			isViewing: function () {
				return this.viewingInvoiceDetails || this.isViewingSetInvoiceStatusForm
			},
			isViewingInvoiceDetails: function () {
				return this.viewingInvoiceDetails
			},
			isViewingSetInvoiceStatusForm: function () {
				return this.approving || this.rejecting
			},
			isViewingDocument: function () {
				return this.viewDocument
			}
		},
		methods: {
			setSelectedRecord: function (id) {
				this.selectedRecord = this.records.filter(x => x.id == id)[0]
			},
			getFileName: function (key) {
				var parts = key.split("/")

				return parts[parts.length - 1]
			},
			viewInvoiceDetails: function (obj) {
				this.setSelectedRecord(obj.id)

				var $this = this

				this.$store.dispatch("Invoices/getInvoice", obj.id).then(function (invoice) {
					$this.invoice = invoice
					$this.viewingInvoiceDetails = true
				})
			},
			hideInvoiceDetails: function () {
				this.selectedRecord = null

				this.viewingInvoiceDetails = false
				this.invoice = null
			},
			openViewingDocument: function (doc) {
				var parts = doc.Key.split("/")

				this.title = parts[parts.length - 1]
				this.filePath = doc.Key
				this.viewDocument = true
			},
			closeViewingDocument: function () {
				this.viewDocument = false
				this.title = null
				this.filePath = null
			},
			showApproveInvoiceForm: function (obj) {
				this.setSelectedRecord(obj.id)

				this.approving = true
			},
			showRejectInvoiceForm: function (obj) {
				this.setSelectedRecord(obj.id)

				this.rejecting = true
			},
			hideSetInvoiceStatusForm: function () {
				this.selectedRecord = null

				this.approving = false
				this.rejecting = false
			},
			saveSetInvoiceStatusForm: function () {
				var $this = this

				this.$store.dispatch("Invoices/getInvoices", 0).then(function () {
					$this.hideSetInvoiceStatusForm()
				})
			}
		}
	};
</script>

<style scoped>
	.mh-time-off .mh-edit-item {
		margin-bottom: 15px;
	}

		.mh-time-off .mh-edit-item .supplier {
			font-size: 17px;
			font-weight: bold;
		}

	.mh-time-off .document {
		cursor: pointer;
	}

	.mh-time-off .line-item {
		font-size: 13px;
	}

	.mh-time-off .totals {
		font-size: 14px;
	}
</style>